import type { FC } from "react";

import { Button } from "../common/Button";
import { FilterChip } from "../common/FilterChip";
import { Text } from "../common/Text";

export interface AdminActiveFilterItem {
  id: string;
  label: string;
  onClear: () => void;
}

interface AdminActiveFiltersRowProps {
  filters: readonly AdminActiveFilterItem[];
  onReset?: () => void;
  totalLabel: string;
}

export const AdminActiveFiltersRow: FC<AdminActiveFiltersRowProps> = ({
  filters,
  onReset,
  totalLabel,
}) => (
  <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 pt-3 dark:border-slate-700">
    <div className="flex flex-wrap items-center gap-2">
      <Text variant="label">View</Text>
      {filters.length > 0 ? (
        filters.map((filter) => (
          <FilterChip key={filter.id} active onClick={filter.onClear}>
            {filter.label}
          </FilterChip>
        ))
      ) : (
        <Text className="leading-5">All records visible</Text>
      )}
    </div>

    <div className="flex flex-wrap items-center gap-2">
      <Text variant="mono" className="tabular-nums">
        {totalLabel}
      </Text>
      {filters.length > 0 && onReset ? (
        <Button variant="ghost" size="sm" onClick={onReset}>
          Clear Filters
        </Button>
      ) : null}
    </div>
  </div>
);
